import { EhsPermission } from "./EhsRoleTypes";

export type PermissionsState = {
  isDirty: boolean;
  permissions: Array<EhsPermission>;
};

export const INITIAL_PERM_STATE: PermissionsState = {
  isDirty: false,
  permissions: [],
};

export type ActionTypes =
  | "init"
  | "add"
  | "remove"
  | "open"
  | "close"
  | "clean";

export type PermissionsAction = {
  type: ActionTypes;
  payload?: any;
};

export function PermissionsReducer(
  state: PermissionsState,
  action: PermissionsAction
) {
  const { payload, type } = action;

  switch (type) {
    case "init": {
      return {
        ...state,
        permissions: payload,
        isDirty: false,
      };
    }

    case "clean": {
      return {
        ...state,
        isDirty: false,
      };
    }

    case "add": {
      return {
        ...state,
        permissions: [...state.permissions, mapAllAvailableToAssigned(payload)],
        isDirty: true,
      };
    }

    case "remove": {
      return {
        ...state,
        permissions: state.permissions.filter((perm) => perm.id !== payload.id),
        isDirty: true,
      };
    }

    case "open": {
      if (state.permissions.some((perm) => perm.id === payload.id)) {
        return { ...state };
      }

      return {
        ...state,
        permissions: [...state.permissions, mapAllAvailableToAssigned(payload)],
        isDirty: true,
      };
    }

    case "close": {
      const permissions = [...state.permissions];
      permissions.forEach((perm) => {
        if (perm.id === payload.permissionId) {
          perm.assignedQualifiers =
            payload.availableQualifiers?.filter(
              (qual) => payload.qualifiers[qual.id]
            ) || [];
        }
      });

      return {
        ...state,
        permissions,
        isDirty: true,
      };
    }

    default: {
      return { ...state };
    }
  }
}

function mapAllAvailableToAssigned(permission: EhsPermission) {
  if ("assignedQualifiers" in permission) return permission;
  return {
    name: permission.name,
    id: permission.id,
    availableQualifiers: permission.availableQualifiers,
    assignedQualifiers: permission.availableQualifiers || [],
  };
}
